export default {
  newRecordResponse: '',
  dbRecordsList: {},
  deleteRecordResponse: '',
  editRecordResponse: '',
  createRecordResponse: '',
  uploadExcelResponse: '',
  userFormFields: '',
  userFormFieldsResponse: '',
  errors: {
    dbRecordsListError: null,
    newDbError: null,
    searchDbRecordsError: null,
    createRecordAndExitError: null,
    uploadExcelError: null,
    deleteRecordError: null,
    editRecordError: null,
    postUserFormFieldsError: null
  },
  loading: {
    createRecord: false,
    recordsList: false,
    uploadExcel: false,
    postUserFormFields: false
  },
  excelId: null
}



// WEBPACK FOOTER //
// ./src/store/db/state.js